import React from "react";

const TalentSectionHeading = ({ eyebrow, title, text, centered = false }) => (
  <div className={`adt-section-heading srm-section-heading scp-section-heading en-section-heading${centered ? " adt-section-heading--center srm-section-heading--center scp-section-heading--center en-section-heading--center" : ""}`}>
    {eyebrow && <span className="adt-eyebrow scp-eyebrow en-eyebrow">{eyebrow}</span>}
    <h2>{title}</h2>
    {text && <p>{text}</p>}
  </div>
);

export default TalentSectionHeading;
